import React, { Component } from "react";
import '../Styles/Certificates.css';
import Carousel from 'react-bootstrap/Carousel';
import certificates from "../Data/certificates";

export default class Certificates extends Component {
  render() {
    return (
      <section className="certificates" id="certificate">
        <div className="certificate-container"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <h1
            className="title-exp"
          >
            Certificados
          </h1>
          <div className="certificate-content">
            <div className="certificate">
              <Carousel interval={null}>
                {
                  certificates.imgs.map((certificate, index) => (
                    <Carousel.Item key={`slide--${index}`}>
                      <a
                        href={ certificates.links[index] }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          className="carousel-image"
                          src={certificate}
                          alt={`slide-${index}`}
                        />
                      </a>
                    </Carousel.Item>
                  ))
                }
              </Carousel>
            </div>
          </div>
        </div>
      </section>
    )
  }
}